export default "__VITE_ASSET__DZU6Cwp$__"